<ng-container *ngIf="vm$ | async as vm">
  <dgx-components-grid-section>
    <dgx-components-grid-container>
      <dgx-components-grid-row>
        <dgx-components-grid-column [xs]="12">
          <h1 class="typog-h1 mb-4">
            {{ 'ARTICLE_SEARCH_RESULTS_TITLE' | translate }}
          </h1>
          <dgx-components-accordion-article-filter-info-block
            [categories]="vm.categories"
            [keyword]="vm.searchTerm"
            [quantity]="vm.articles.articles.length + vm.videos.videos.length"
            [subcategories]="vm.subcategories"
          />
        </dgx-components-grid-column>
      </dgx-components-grid-row>
      <dgx-components-grid-row>
        <dgx-components-grid-column [lg]="4" [xs]="12" class="mt-4">
          <dg-article-filter
            [sharedSectionLoading]="!vm.articles.articles.length"
          />
        </dgx-components-grid-column>
        <dgx-components-grid-column
          [lg]="8"
          [xs]="12"
          class="article-search__results-block"
        >
          <dgx-components-keyword-search-results-block
            [articles]="vm.articles"
            [displayableItems]="isSearchSubject ? 100 : 50"
            [searchTerm]="vm.searchTerm"
            [videos]="vm.videos"
          />
        </dgx-components-grid-column>
      </dgx-components-grid-row>
    </dgx-components-grid-container>
  </dgx-components-grid-section>
</ng-container>
